import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/common";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setSession(data.token, data.user);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (err) {
        localStorage.setItem("auth_error", err?.response?.data?.detail || "Sign-in failed");
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [navigate, setSession]);

  return (
    <div className="h-screen flex flex-col items-center justify-center gap-6">
      <Logo className="h-10" />
      <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      <p className="text-sm text-muted-foreground">Signing you in…</p>
    </div>
  );
}
